import * as subscriberAction from "./subscriberAction";

export const subscriberFeatureKey = "subscriberInfo";

const initialState = {
  loading: false,
  errorMsg: "",
  subscriber: [],
};

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case subscriberAction.GET_SUBSCRIBER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case subscriberAction.GET_SUBSCRIBER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        subscriber: payload.data,
      };
    case subscriberAction.GET_SUBSCRIBER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    default:
      return state;
  }
};
